<template>
  <div>
    <div v-if="list && list.length == 0">
      暂无可用标签
    </div>
    <div v-if="list && list.length > 0" style="height: 218px; padding: 5px;">
      <div v-for="item in list" :key="item.id" :class="[item.checked ? 'tag-checked': 'tag-item']" @click="checkedOne(item)">
        {{item.content}}
      </div>
    </div>
  </div>
</template>
<script>
  import clonedeep from 'lodash.clonedeep'
  export default {
    props: ['initials'],
    created () {
      this.list = clonedeep(this.initials).filter((o) => {
        return o.type == '02'
      })
    },
    data () {
      return {
        list: [],
        outputs: []
      }
    },
    methods: {
      checkedOne (item) {
        item.checked = !item.checked
        let idIndex =  this.$utils.findElem(this.outputs, 'id', item.id)
        if (idIndex >= 0) {
          this.outputs.splice(idIndex, 1)
        } else {
          this.outputs.push(item)
        }
        this.$emit('selected', this.outputs)
      }
    }
  }
</script>
<style scoped>
  .tag-item {
    min-width: 40px;
    border-radius: 5px;
    font-size: 12px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    padding: 0 1px;
    margin-right: 5px;
    margin-bottom: 5px;
    color: #666;
    border: 1px solid #666;
    position:  relative;
    display: inline-block;
    float: left;
    cursor: pointer;
    z-index: 6;
  }
  .tag-checked {
    min-width: 40px;
    border-radius: 5px;
    font-size: 12px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    padding: 0 1px;
    margin-right: 5px;
    margin-bottom: 5px;
    color: #ff3633;
    border: 1px solid #ff3633;
    position:  relative;
    display: inline-block;
    float: left;
    cursor: pointer;
    z-index: 6;
  }
</style>



// WEBPACK FOOTER //
// src/components/byl/tagPicker/simplePicker.vue